import NumberFormatOptions = Intl.NumberFormatOptions;
import ResolvedNumberFormatOptions = Intl.ResolvedNumberFormatOptions;

export class CachedNumberFormat extends Intl.NumberFormat {

    public static createOrGetFromCache(
        locales?: string | string[],
        options?: NumberFormatOptions
    ): CachedNumberFormat {
        const cacheKey = CachedNumberFormat.getCacheKey({locales, options});

        let result: CachedNumberFormat = CachedNumberFormat.numberFormatCache[cacheKey];

        if (!result) {
            result = new CachedNumberFormat(locales, options);

            CachedNumberFormat.numberFormatCache[cacheKey] = result;
        }

        return result;
    }

    private static readonly numberFormatCache: Record<string, CachedNumberFormat> = {};

    private static getCacheKey(numberFormatParams: {
        locales: string | string[];
        options: NumberFormatOptions;
    }): string {
        return JSON.stringify(numberFormatParams);
    }

    private readonly options: ResolvedNumberFormatOptions;

    constructor(
        locales?: string | string[],
        options?: NumberFormatOptions
    ) {
        super(locales, options);

        this.options = this.resolvedOptions();
    }

    public override resolvedOptions(): ResolvedNumberFormatOptions {
        return this.options || super.resolvedOptions();
    }

}
